import React from "react";

interface IconProps {
    className?: string;
  }

const BucketIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    enableBackground="new 0 0 24 24"
    height="512"
    viewBox="0 0 24 24"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="m21 20h-18c-.552 0-1 .448-1 1s.448 1 1 1h18c.552 0 1-.448 1-1s-.448-1-1-1z" /><path d="m9.18 18.999c.753 0 1.506-.287 2.079-.86l7.547-7.547c.391-.391.391-1.023 0-1.414l-8.233-8.233c-.391-.391-1.023-.391-1.414 0l-7.548 7.546c-1.146 1.146-1.146 3.012 0 4.158l5.489 5.489c.574.574 1.327.861 2.08.861zm.686-15.934 6.819 6.819-.116.116h-13.606c.024-.03.035-.067.063-.095z" /><path d="m17 16.417c0 1.424 1.122 2.583 2.5 2.583s2.5-1.159 2.5-2.583c0-1.148-1.434-3.413-1.874-4.079-.277-.422-.975-.422-1.252 0-.44.666-1.874 2.931-1.874 4.079z" />
  </svg>
);

export default BucketIcon;
